<template>
	<div class="custon-overlay">
		<v-container absolute fluid fill-height style="justify-content: center">
			<v-progress-circular :size="120" :width="7" indeterminate color="white"></v-progress-circular>
		</v-container>
	</div>
</template>

<script>
export default {
	name: 'Loader'
}
</script>
